import React from 'react';
import { getFieldDropOff } from '../../../services/eventAnalyticsService';

const FieldDropOff = () => {
  const fields = getFieldDropOff();
  const maxDrop = Math.max(...fields?.map(f => f?.dropPct));

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base font-semibold text-foreground">Field-Level Drop-off</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Where users abandon form fields</p>
        </div>
      </div>
      <div className="space-y-3">
        {fields?.map((field) => {
          const severity = field?.dropPct >= 15 ? 'error' : field?.dropPct >= 8 ? 'warning' : 'success';
          const barColor = severity === 'error' ? '#ef4444' : severity === 'warning' ? '#f59e0b' : '#107570';
          const pctOfMax = (field?.dropPct / maxDrop) * 100;

          return (
            <div key={field?.field}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs text-foreground font-medium">{field?.field}</span>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-muted-foreground">{field?.completions?.toLocaleString()} completed</span>
                  <span
                    className="text-xs font-semibold w-10 text-right"
                    style={{ color: barColor }}
                  >
                    -{field?.dropPct}%
                  </span>
                </div>
              </div>
              <div className="h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500"
                  style={{ width: `${pctOfMax}%`, backgroundColor: barColor }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex items-center gap-4 mt-4 pt-4 border-t border-border">
        <div className="flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-success" />
          <span className="text-[10px] text-muted-foreground">Low (&lt;8%)</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-warning" />
          <span className="text-[10px] text-muted-foreground">Medium (8–15%)</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-error" />
          <span className="text-[10px] text-muted-foreground">High (&gt;15%)</span>
        </div>
      </div>
    </div>
  );
};

export default FieldDropOff;
